import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { userSettingsApi } from '@/api/userSettings'
import { useTenant } from '@/contexts/TenantContext'
import { invalidateWorkflowTriggerSchemas } from './useWorkflowDefinitions'
import { invalidateClaudeAuthAvailability } from './useProjectSettings'

function useClaudeTokenQueryKey() {
  const { currentTenant } = useTenant()
  return ['user', 'settings', 'claude-token', currentTenant?.id ?? ''] as const
}

export function useUserClaudeToken(enabled = true) {
  const queryKey = useClaudeTokenQueryKey()
  return useQuery({
    queryKey,
    queryFn: userSettingsApi.getClaudeToken,
    enabled,
  })
}

export function useSaveUserClaudeToken() {
  const queryClient = useQueryClient()
  const queryKey = useClaudeTokenQueryKey()
  return useMutation({
    mutationFn: (token: string) => userSettingsApi.saveClaudeToken(token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey })
      invalidateClaudeAuthAvailability(queryClient)
      invalidateWorkflowTriggerSchemas(queryClient)
    },
  })
}

export function useDeleteUserClaudeToken() {
  const queryClient = useQueryClient()
  const queryKey = useClaudeTokenQueryKey()
  return useMutation({
    mutationFn: () => userSettingsApi.deleteClaudeToken(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey })
      invalidateClaudeAuthAvailability(queryClient)
      invalidateWorkflowTriggerSchemas(queryClient)
    },
  })
}
